import { useState } from 'react'
import { CategoricalChartFunc } from 'recharts/types/chart/generateCategoricalChart'

export const useBarChartHoverIndex = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null)

  const handleBarMouseMove: CategoricalChartFunc = data => {
    if (data.isTooltipActive) {
      if (data.activeTooltipIndex !== hoveredIndex) {
        setHoveredIndex(data.activeTooltipIndex ?? null)
      }
    } else {
      setHoveredIndex(null)
    }
  }

  const handleBarMouseLeave = () => setHoveredIndex(null)

  return [hoveredIndex, handleBarMouseMove, handleBarMouseLeave] as Parameters<
    (
      index: number | null,
      handleBarMouseMove: CategoricalChartFunc,
      handleBarMouseLeave: () => void
    ) => void
  >
}
